<template>
  <v-container fluid>
    <v-row dense>
      <v-col v-for="(group, index) in groupedCategories" :key="index" cols="12">
        <v-card class="group-wrapper" outlined>
          <v-card-title class="cyan--text text--accent-2">
            <v-icon left color="cyan lighten-2">mdi-cog</v-icon>
            {{ group.title }}
          </v-card-title>
          <v-divider class="cyan-divider"></v-divider>

          <v-card-text>
            <v-row>
              <v-col
                v-for="(item, i) in group.items"
                :key="i"
                cols="12"
                sm="6"
                md="4"
                lg="3"
              >
                <v-list-item class="py-1">
                  <v-list-item-icon>
                    <v-icon color="cyan lighten-2" small>{{
                      item.icon
                    }}</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-subtitle class="white--text">
                      {{ item.text }}
                    </v-list-item-subtitle>
                    <v-list-item-title
                      class="cyan--text text--lighten-2 font-weight-bold"
                    >
                      {{ getValue(item) }}
                      <span class="unit">{{ item.unit }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import objPath from "object-path";

export default {
  props: {
    dataset: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    numberGroups: [
      {
        title: "Solar Information",
        items: [
          {
            text: "Solar Current",
            value: "solar_current",
            unit: "A",
            icon: "mdi-flash",
          },
          {
            text: "Solar Voltage",
            value: "solar_voltage",
            unit: "V",
            icon: "mdi-flash",
          },
          {
            text: "Solar Power",
            value: "solar_power",
            unit: "W",
            icon: "mdi-flash",
          },
          {
            text: "Solar Status",
            value: "solar_status",
            unit: "",
            icon: "mdi-check-circle-outline",
          },
        ],
      },
      {
        title: "Battery Information",
        items: [
          {
            text: "Battery Voltage",
            value: "battery_voltage",
            unit: "V",
            icon: "mdi-battery",
          },
          {
            text: "Max Voltage",
            value: "battery_max_voltage",
            unit: "V",
            icon: "mdi-arrow-up-bold",
          },
          {
            text: "Battery Temp",
            value: "battery_temp",
            unit: "°C",
            icon: "mdi-thermometer",
          },
          {
            text: "Charging Status",
            value: "battery_charging_status",
            unit: "",
            icon: "mdi-battery-charging",
          },
          {
            text: "Battery Current",
            value: "battery_current",
            unit: "A",
            icon: "mdi-flash",
          },
          {
            text: "Min Voltage",
            value: "battery_min_voltage",
            unit: "V",
            icon: "mdi-arrow-down-bold",
          },
          {
            text: "Battery SOC",
            value: "battery_soc",
            unit: "%",
            icon: "mdi-percent",
          },
          {
            text: "Battery Status",
            value: "battery_status",
            unit: "",
            icon: "mdi-check-circle-outline",
          },
        ],
      },
      {
        title: "DC Load Information",
        items: [
          {
            text: "Load Current",
            value: "load_current",
            unit: "A",
            icon: "mdi-flash",
          },
          {
            text: "Load Voltage",
            value: "load_voltage",
            unit: "V",
            icon: "mdi-flash",
          },
          {
            text: "Load Power",
            value: "load_power",
            unit: "W",
            icon: "mdi-power",
          },
          {
            text: "Load Status",
            value: "load_status",
            unit: "",
            icon: "mdi-check-circle-outline",
          },
        ],
      },
      {
        title: "Controller Information",
        items: [
          {
            text: "Device Temp",
            value: "scc_temp",
            unit: "°C",
            icon: "mdi-thermometer",
          },
          {
            text: "Device Status",
            value: "scc_status",
            unit: "",
            icon: "mdi-check-circle-outline",
          },
        ],
      },
      {
        title: "Daily Energy",
        items: [
          {
            text: "Energy Result",
            value: "energy_generated",
            unit: "Wh",
            icon: "mdi-lightning-bolt",
          },
          {
            text: "Energy Consumption",
            value: "energy_consumed",
            unit: "Wh",
            icon: "mdi-flash-outline",
          },
        ],
      },
    ],
  }),
  computed: {
    groupedCategories() {
      return this.numberGroups;
    },
  },
  methods: {
    getValue(item) {
      const val = objPath.get(this.dataset, item.value);
      return val !== undefined ? val : "-";
    },
  },
};
</script>

<style scoped>
.v-container {
  background: transparent;
}

.group-wrapper {
  background: #0c203d;
  border: 1px solid rgba(0, 255, 255, 0.25);
  border-radius: 12px;
  box-shadow: 0 0 12px rgba(0, 255, 255, 0.1);
  color: #e0f7fa;
  transition: all 0.25s ease;
  margin-bottom: 16px;
}
.group-wrapper:hover {
  box-shadow: 0 0 16px rgba(0, 255, 255, 0.25);
  transform: translateY(-2px);
}

.v-card-title {
  font-weight: 600;
  letter-spacing: 0.3px;
}

.unit {
  font-size: 0.85rem !important;
  opacity: 0.7;
}

.v-list-item {
  background-color: rgba(255, 255, 255, 0.03) !important;
  border-radius: 8px;
  transition: 0.2s;
}
.v-list-item:hover {
  background-color: rgba(0, 255, 255, 0.1);
}

.v-list-item-title {
  font-size: 1.2rem !important;
}

.v-list-item-subtitle {
  font-size: 1.2rem !important;
  opacity: 0.8;
}

.v-list-item__subtitle {
  font-size: 1rem !important;
  opacity: 0.8;
}

/* INI UNTUK FONT BIRU ("0.00 A") */
.v-list-item__title {
  font-size: 1rem !important;
}

.v-list-item__title,
.v-list-item__subtitle {
  flex: 1 1 100%;
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  word-break: break-word;
}

.cyan-divider {
  border-color: #00ffff !important;
  opacity: 0.4;
}
</style>
